
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models",
      function () {
        return require("private-next-pages/models/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models"])
      });
    }
  